import './Footer.scss';
import React from 'react';

const Footer = (year: any) => {
  const date = new Date().getFullYear();
  return (
    <div className='footer-app'>
      {/* <div className='pcolorFooter'>
        <div className='section-color-tage1'></div>
        <div className='section-color-tage2'></div>
        <div className='section-color-tage3'></div>
      </div> */}
      <div className=' m-0 p-4 text-light border-0 bg-dark' id='hide-on-print'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-3 text-center mt-2'>
              <div>
                <div>
                  <i className='fa fa-map-marker  fa-2x' aria-hidden='true'></i>
                  <br />
                  <h6 className='font-weight-bold text-white'>PSC</h6>
                  <small>
                    Police Service Commission, Corporate Headquarters
                  </small>{' '}
                  <br />
                  <small>
                    Plot 64, Cadastral Zone B16, Sector Centre B, Jabi, Abuja.
                  </small>
                </div>
                <div className=' mt-2'>
                  <i className='fa fa-calendar fa-2x' aria-hidden='true'></i>
                  <br />
                  <small>Monday—Friday: 8:00AM - 4:00PM</small>
                  <br />
                  <small>(Except on Public Holidays)</small>
                </div>
              </div>
            </div>

            <div className='col-md-3 text-center mt-2'>
              <i className='fa fa-phone fa-2x'></i>
              <br />
              <h6 className='font-weight-bold text-white'>Call us</h6>
               {/* 09060483893, 09135006008 or 09135006009 */}

              <small>+2349060483893,<br/> +2349135006008, <br/> +2349135006009</small>
            </div>
            <div className='col-md-3 text-center mt-2'>
              <div className=' text-wrap p-1'>
                <i className='fa fa-envelope fa-2x'></i>
                <br />
                <h6 className='font-weight-bold text-white'>Send us a mail</h6>
                <small>icto@psc.gov.ng</small>
              </div>
            </div>
            <div className='col-md-3 text-center mt-2'>
              <div>
                <i className='fa fa-users fa-2x'></i>
              </div>
              <h6 className='font-weight-bold text-white'>We are social</h6>
                Twitter: @PSCNigeria
            </div>
          </div>
        </div>
      </div>

      <div className=' m-0 p-0 foot-last bg-dark border-top border-white' id='hide-on-print'>
        <div className='container-fluid text-white'>
          <div className='text-center font-weight-bolder p-ttop text-white'>
            <div className='font-weight-bolder font-size-16 '>
              Powered by:{' '}
              <span className='text-white'>Police Service Commission</span>
            </div>
            &copy; {date} - All Right Reserved.
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
